import DepressionTest from "../components/assessment/depressionTest"
import './SelfTest.css'
const DepressionTestPage =()=>{
    return (
        <>
        <div className="DP">
       <DepressionTest/>
        </div>
        </>
    )
}

export default DepressionTestPage;